var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('router-link',{staticClass:"title",attrs:{"to":{name: 'ArticleList'}}},[_vm._v(" Pratyaksh's Blog ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }